export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'PRIVATE_LAND_GET_FILTER_VALUES':
      return payload
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
